import { Form } from 'antd';
import PhysicalImproveItem from './PhysicalImproveItem';

import cx from './index.module.scss';

interface Props {
  physicalImproveListProblems: AIDiagnoseSubmitParams['physicalImproveList'];
  handleDelete: (value: Diagnose, therapyType: AIDiagnose.TherapyType) => void;
}

const PhysicalImprove: React.FC<Props> = ({ physicalImproveListProblems, handleDelete }) => {
  return (
    <div className={cx('wrapper')}>
      <div className={cx('header')}>
        <div>体质调理</div>
        <div onClick={() => handleDelete('physicalImproveList', 'physicalImprove')}>删除</div>
      </div>

      <div className={cx('content')}>
        <Form.List name="physicalImproveList">
          {fields =>
            fields.map(({ key, name }) => (
              <div key={key}>
                <Form.Item noStyle name={[name, 'problem']} />
                <Form.Item noStyle name={[name, 'level']}>
                  <PhysicalImproveItem name={physicalImproveListProblems?.[name]?.problem} />
                </Form.Item>
              </div>
            ))
          }
        </Form.List>
      </div>
    </div>
  );
};

export default PhysicalImprove;
